import PoolSectionHeader from './PoolSectionHeader.vue'

export default PoolSectionHeader
